import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../../locale/useTranslation';
import * as API from '../../../framework/API/api';
import ActionButton from '../../../framework/forms/helpercomponents/buttons/ActionButton';
import { FILEURL, MAM_STATUS, TOAST_TYPES } from '../../../framework/constant/constant';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { Loader } from '../../../framework/forms/helpercomponents/Loader';
import { ArrayCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ArrayCell';
import { TimeCell } from '../../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import { utility } from '../../../framework/utility/utilityProvider';
import MyStatusCell from '../../../components/MyStatusCell';
import { LocalDateTimeColumn } from '../../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import MAMStatusCell from '../../../components/MAMStatusCell';
import { CheckboxCell } from '../../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell';
import OfferGridCollection from '../../MediaLibrary/NodeTreeView/OfferGridCollection';
import ToastNotification from '../../../components/ToastNotification';

const PurgeListReportCollection = () => {

    const lang = useTranslation();

    const borderStyle = {
        border: "1px solid #ced4da",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#FAFAFA"
    }

    const [gridData, setGridData] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState({ skip: 0, take: 50 });
    const [isLoading, setIsLoading] = useState(true);
    const [showOffersForm, setShowOffersForm] = useState({ show: false, item: {} });

    useEffect(() => {
        loadData({ pagination: { per_page: page.take, current_page: 1 } });
    }, []);

    const loadData = async ({ pagination }) => {
        setIsLoading(true);
        // Load data
        const payload = {
            isExport: false,
            page: pagination.current_page,
            perPage: pagination.per_page
        }
        let res = await API.exportPurgeListReport(payload);
        console.log(res);
        if (res.success) {
            setTotal(res?.pagination?.total);
            setGridData(res.data);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setIsLoading(false);
    }

    const handleExport = async () => {
        const payload = {
            isExport: true
        }
        let res = await API.exportPurgeListReport(payload);
        console.log(res);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data[0], "_blank");
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_exported_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const pageChange = async (e) => {
        let current_page = e.page.skip / e.page.take + 1;
        setPage(e.page);
        await loadData({ pagination: { per_page: e.page.take, current_page: current_page } });
    };

    const handlePurgeReport = async () => {
        const current_page = page.skip / page.take + 1
        const payload = {
            isExport: false,
            isPurged: true,
            page: current_page,
            perPage: page.take
        }
        let res = await API.exportPurgeListReport(payload);
        console.log(res);
        if (res.success) {
            setTotal(res?.pagination?.total);
            setGridData(res.data);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const onShowOffers = (dataItem = {}) => {
        setShowOffersForm({ show: true, item: dataItem });
    }

    const showOffersCell = (props) => {
        return (
            <td>
                <div style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={() => {
                        onShowOffers(props.dataItem.transmission.inactiveOffers);
                    }}
                >
                    {props.dataItem.transmission.inactiveOffersCount}
                </div>
            </td>
        )
    }

    return (
        <div className='m-1'>
            <h1 className="page-title txt-color-bludeDark">
                <i className="fa fa-table marlr" style={{ fontSize: 20, color: 'GrayText' }} />
                <span>{lang.purge_list_report_page_breadcrumb}</span>
            </h1>
            <div className="border p-2 form-group with-3d-effect" style={borderStyle}>
                <ActionButton title={lang.export_button_tooltip} name={lang.export_button_text} onClick={handleExport} />
                <ActionButton btnColor="success" title={lang.purge_button_tooltip} name={lang.purge_button_text} onClick={handlePurgeReport} />
                <hr />
                {isLoading ? <Loader /> :
                    <Grid
                        style={{ height: 'calc(100vh - 210px)' }}
                        sortable={true}
                        pageable={true}
                        skip={page.skip}
                        take={page.take}
                        onPageChange={pageChange}
                        total={total}
                        resizable={true}
                        data={gridData}
                    >
                        <GridColumn field="SID" title="MAM ID" width="120px" />
                        <GridColumn field="Status" title="MAM Status" width="120px" cell={MAMStatusCell} />
                        <GridColumn field="AssetId" title="Asset ID" width="120px" />
                        <GridColumn field="Title" title="Title" width="200px" />
                        <GridColumn field="ActualDuration" title="Actual Duration" width="120px" cell={TimeCell} />
                        <GridColumn field="transmission.inactiveOffersCount" title="Offer Count" width="100px" cell={showOffersCell} />
                        <GridColumn field="transmission.CSID" title="Transmission ID" width="120px" />
                        <GridColumn field="transmission.inactiveOffer.Title" title="Offer Title" width="150px" />
                        <GridColumn field="transmission.inactiveOffer.StartDateTime" title="Offer Start Time" width="180px" cell={LocalDateTimeColumn} />
                        <GridColumn field="transmission.inactiveOffer.EndDateTime" title="Offer End Time" width="180px" cell={LocalDateTimeColumn} />
                        <GridColumn field="transmission.catalogue.Description" title="Catalogue" width="150px" />
                        <GridColumn field="transmission.nodes" title="Nodes ID" format="CSID" cell={ArrayCell} width="180px" />
                        <GridColumn field="transmission.nodes" title="Nodes" format="Name" cell={ArrayCell} width="180px" />
                        <GridColumn field="transmission.parentNode.Name" title="Parent Node" width="150px" />
                        <GridColumn field="transmission.transmissionType.Name" title="Transmission Type" width="150px" />
                        <GridColumn field="transmission.inactiveOffer.PriceCode.Code" title="Price Code" width="150px" />
                        <GridColumn field="transmission.inactiveOffer.PriceCode.Price" title="Price" width="150px" />
                        <GridColumn field="transmission.inactiveOffer.PriceCode.Currency.Description" title="Currency" width="150px" />
                        <GridColumn field="isPurged" title="Purged" width="150px" cell={CheckboxCell} />
                    </Grid>}
            </div>
            {showOffersForm.show && <OfferGridCollection onClose={() => setShowOffersForm({ show: false, item: {} })} data={showOffersForm.item} />}
        </div>
    )
}

export default PurgeListReportCollection;